import React from 'react'
import { useProjectContext } from '../../context/ProjectContext'
import { calculateYardage } from '../../utils/yardageCalculator'

const YardageCalculator = () => {
  const {
    project,
    threadType,
    strandsUsed,
    perleSize,
  } = useProjectContext()

  const yardageData = calculateYardage(project, {
  threadType,
  strandsUsed,
})

  return (
    <div className="yardage-calculator">
      <h3>Yardage Estimate</h3>

      <div
        className="yardage-settings-note"
        style={{ marginBottom: '18px' }}
      >
        <div>        
          <strong>Thread Type:</strong>{' '}
          {threadType === 'stranded' ? 'Stranded Floss' : 'Pearl Cotton'}
        </div>

        {threadType === 'stranded' ? (
          <div>
            <strong>Strands Used:</strong> {strandsUsed}
          </div>
        ) : (
          <div>
            <strong>Perle Size:</strong> {perleSize}
          </div>
        )}
      </div>

      <div style={{ height: '18px' }} />

      {project.palette.length === 0 ? (
        <p style={{ fontSize: '0.9rem', color: 'var(--accent-color)' }}>
          Add colors to your palette to see yardage estimates.
        </p>
      ) : (

        <div style={{ paddingTop: '18px', width: '100%', minWidth: 0 }}>
          {yardageData.map((item) => {
            const swatchColor = item.color?.hex || item.color?.color || '#ffffff'
            const colorCode = item.color?.code || ''
            const colorName = item.color?.name || ''

            return (
             <div
               key={colorCode}
               style={{
                 display: 'flex',
                 alignItems: 'flex-start',
                 gap: '10px',
                 marginBottom: '16px',
                 width: '100%',
                 minWidth: 0,
               }}
            >
               <span
                 style={{
                 width: '30px',
                 height: '30px',
                 borderRadius: '6px',
                 border: '1.5px solid #3a3836',
                 backgroundColor: swatchColor,
                 flexShrink: 0,
                 display: 'inline-block',
               }}
             />

            <div
              style={{
                flex: '1 1 auto',
                minWidth: 0,
                maxWidth: '100%',
              }}
            >
              <div
                style={{
                fontWeight: 'bold',
                overflowWrap: 'anywhere',
                wordBreak: 'break-word',
              }}
          >
              {colorCode} - {colorName}
            </div>
            <div>Cells: {item.cellCount}</div>
            <div>Estimated: {Number(item.yards).toFixed(1)} yards</div>
            <div
              style={{
                overflowWrap: 'anywhere',
                wordBreak: 'break-word',
              }}
           >
              DMC Skeins: {item.skeins} ({Number(item.yardsPerUnit).toFixed(1)} yds each)
            </div>
          </div>
        </div>
            )
          })}

          <div style={{ marginTop: '1rem', fontWeight: 'bold' }}>
            Total:{' '}
            {yardageData
              .reduce((sum, item) => sum + Number(item.yards || 0), 0)
              .toFixed(1)}{' '}
            yards
          </div>

          <div
            style={{
              marginTop: '0.5rem',
              fontSize: '0.85rem',
              color: 'var(--accent-color)',
            }}
          >
            Note: Estimates are approximate and include a 10% buffer for waste.
          </div>
        </div>
      )}
    </div>
  )
}

export default YardageCalculator